import { render, staticRenderFns } from "./BeforeSessionExpire.vue?vue&type=template&id=3c536922&"
import script from "./BeforeSessionExpire.vue?vue&type=script&lang=js&"
export * from "./BeforeSessionExpire.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports